type LockedChapterDestinationArgs = {
  locale: string;
  storySlug: string;
  chapterNumber: number;
  userId: string | undefined;
};

// Client-side mirror of the server gate in countdown/[storySlug]/chapter/[chapterNumber]/page.tsx:
// an anonymous visitor (no userId cookie) hitting a locked chapter is redirect()ed to /p/login.
// Soft-navving through /countdown first commits an empty countdown frame (a redirecting page
// renders nothing) and then swaps in the complete login payload, bypassing the login route's
// loading.tsx — the login-wall layout shift (DEV-5926). Navigating straight to the login URL the
// server would redirect to keeps the transition on a route with an instant loading state. The
// server gate stays authoritative for hard navigations and any client/server auth-state drift.
export const lockedChapterDestination = ({
  locale,
  storySlug,
  chapterNumber,
  userId,
}: LockedChapterDestinationArgs): string => {
  const countdownPath = `/countdown/${storySlug}/chapter/${chapterNumber}`;

  if (!userId) {
    return `/${locale}/p/login?redirect=${encodeURIComponent(countdownPath)}`;
  }

  return `/${locale}${countdownPath}`;
};
